// src/utils/config.ts
// API URL configuration based on environment
export const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:8000' 
  : 'https://digitalaim.onrender.com';

export const config = {
    API_URL,
    
    PRODUCTION_DOMAINS: [
        'digitalaim-frontend.onrender.com',
        'thedigitalaim.com',
        'www.thedigitalaim.com'
    ],
    
    IS_PRODUCTION: process.env.NODE_ENV === 'production',
    
    // These endpoint paths are correct
    endpoints: {
        templates: '/api/templates',
        documents: '/api/documents',
        analysis: '/api/analyze/pdf',
        ai: '/ai/chat',
        auth: {
            login: '/simple-token',
            profile: '/users/me'
        }
    }
};

// Export default for flexibility in imports
export default config;